// lib/hooks.js
import { useDispatch, useSelector, useStore } from 'react-redux'

export const useAppDispatch = () => useDispatch()
export const useAppSelector = useSelector
export const useAppStore    = useStore
